// 📄 badiZService.ts
// Catálogo de BAdIs y Objetos ABAP personalizados (desarrollos Z) por
// proyecto — mismo patrón de acceso que transaccionZService.ts: Firestore
// DIRECTO desde el cliente (colección projects/{projectId}/badisZ),
// protegido por firestore.rules (mismo criterio exacto que transaccionesZ).
import {
  collection,
  doc,
  getDocs,
  setDoc,
  updateDoc,
  deleteDoc,
  serverTimestamp,
  Timestamp
} from "firebase/firestore";
import { db } from "../firebase";
import { SolucionBadi } from "./catalogoBadisService.ts";
import { SistemaAmbiente } from "./transaccionZService.ts";

export interface BadiZData {
  nombre: string;
  clase: string;
  interfaz: string;
  descripcion: string;
  solucion: SolucionBadi;
  responsable: string;
  sistemasDisponibles: SistemaAmbiente[];
  fechaImplementacion: Timestamp | null;
  rolPermiso: string;
  notas: string;
}

export interface BadiZ extends BadiZData {
  id: string;
  creadoPor: string;
  creadoEn: any;
  actualizadoEn: any;
}

const badisZRef = (projectId: string) => collection(db, "projects", projectId, "badisZ");
const badiZRef = (projectId: string, id: string) => doc(db, "projects", projectId, "badisZ", id);

export const getBadisZ = async (projectId: string): Promise<BadiZ[]> => {
  const snap = await getDocs(badisZRef(projectId));
  return snap.docs
    .map((d) => ({ id: d.id, ...(d.data() as Omit<BadiZ, "id">) }))
    .sort((a, b) => a.nombre.localeCompare(b.nombre));
};

export const crearBadiZ = async (projectId: string, data: BadiZData, creadoPor: string): Promise<string> => {
  if (!data.nombre.trim()) throw new Error("El nombre es obligatorio.");

  const ref = doc(badisZRef(projectId));
  await setDoc(ref, {
    ...data,
    nombre: data.nombre.trim(),
    creadoPor,
    creadoEn: serverTimestamp(),
    actualizadoEn: serverTimestamp()
  });
  return ref.id;
};

export const actualizarBadiZ = async (projectId: string, id: string, data: BadiZData): Promise<void> => {
  if (!data.nombre.trim()) throw new Error("El nombre es obligatorio.");

  await updateDoc(badiZRef(projectId, id), {
    ...data,
    nombre: data.nombre.trim(),
    actualizadoEn: serverTimestamp()
  });
};

export const eliminarBadiZ = async (projectId: string, id: string): Promise<void> => {
  await deleteDoc(badiZRef(projectId, id));
};
